import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  margin: 0 0;

  table {
    border-top: 1px solid #bbb;
    width: 100%;

    th {
      text-align: left;
      font-size: 14px;
      padding: 10px;
      width: 230px;
    }

    td {
      padding: 10px;
      height: 34px;
    }
  }
`;

const InputWrapDiv = ({ children, className = "" }) => {
  return <StyledDiv className={`${className}`}>{children}</StyledDiv>;
};

export default InputWrapDiv;
